import { render, staticRenderFns } from "./formRencanaAksiPusat.vue?vue&type=template&id=dfecb6b6&scoped=true&"
import script from "./formRencanaAksiPusat.vue?vue&type=script&lang=js&"
export * from "./formRencanaAksiPusat.vue?vue&type=script&lang=js&"
import style0 from "./formRencanaAksiPusat.vue?vue&type=style&index=0&id=dfecb6b6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dfecb6b6",
  null
  
)

export default component.exports